import React from 'react';
import { Star, ExternalLink } from 'lucide-react';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { reviews } from '../utils/mockData';

const Reviews = () => {
  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-br from-slate-50 via-blue-50 to-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl font-bold text-slate-900 mb-6">Customer Reviews</h1>
          <div className="flex justify-center items-center space-x-3 mb-4">
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="w-8 h-8 fill-yellow-400 text-yellow-400" />
            ))}
            <span className="text-3xl font-bold text-slate-900">5</span>
          </div>
          <p className="text-xl text-slate-600 mb-8">
            Based on 01+ reviews from satisfied clients
          </p>
          <Button variant="outline" size="lg"
          onClick={() => window.open("https://share.google/cLX3fEJFLz2h48iEb")}>
            <ExternalLink className="w-5 h-5 mr-2"/>
            Review Us on Google
          </Button>
        </div>
      </section>

      {/* Reviews Grid */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {reviews.map((review) => (
              <Card key={review.id} className="p-6 hover:shadow-xl transition-shadow">
                <div className="flex items-center space-x-4 mb-4">
                  <img
                    src={review.avatar}
                    alt={review.name}
                    className="w-14 h-14 rounded-full"
                  />
                  <div>
                    <h4 className="font-semibold text-slate-900">{review.name}</h4>
                    <p className="text-sm text-slate-500">{review.date}</p>
                  </div>
                </div>
                <div className="flex space-x-1 mb-4">
                  {[...Array(review.rating)].map((_, i) => (
                    <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
                  ))}
                </div>
                <p className="text-slate-600">{review.text}</p>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Trust Section */}
      <section className="py-20 bg-slate-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-slate-900 mb-4">100% Satisfaction Guarantee</h2>
          <p className="text-lg text-slate-600 mb-8">
            We are committed to 100% customer satisfaction. If you are not completely satisfied with our clean, we will send our team back to reclean or provide a partial refund.
          </p>
        </div>
      </section>
    </div>
  );
};

export default Reviews;